import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLocation, useMatch } from 'react-router-dom';
import { Button, HStack, IconButton, VStack, Text } from '@chakra-ui/react';
import classNames from 'classnames';

import { OverrideBackground } from './index';
import Title from './Title';
import Toolbar from './UnitPageComponents/Toolbar';
import ContentComponent from './UnitPageComponents/Content';
import Sidebar from './UnitPageComponents/Sidebar';
import useGetUnitDataGql, { State } from './hooks/useGetUnitDataGql';
import { AuthContext, User } from '../../../../context/AuthProvider';
import Loader from '../../../../components/Loader';
import FeedbackModal from './FeedbackModal';
import { axiosWrapper } from '../../../../hooks/axios';
import { FolderTreeIcon } from '../../../../components/icons';
import SelectTrackAndStudyGroupModal from './UnitPageComponents/SelectTrackAndStudyGroupModal';
import ClassPage from '../Class';
import { useQueryParam } from '../../../../hooks/useQueryParams';
import useStudyGroupContentSettings from './hooks/useStudyGroupContentSettings';
import { HamburgerIcon } from '@chakra-ui/icons';
import updateQueryParams from '../../../../helpers/updateQueryParams';
import { useTranslation } from 'react-i18next';
import { useIsMobile } from '../../../../hooks/isMobile';
import { useIsTablet } from '../../../../hooks/isTablet';
interface Props {
  id: string;
  programId: string;
  className: string;
  unit: { getRoute: (programId: string, id: string) => string };
  module: { getRoute: (programId: string, id: string) => string };
  content: { getRoute: (programId: string, id: string) => string };
}

const UnitPageUnStyled: React.FC<Props> = (props) => {
  const context = useContext(AuthContext) as User;
  const location = useLocation();
  const match = useMatch('/program/:programId/:contentLevel/:id/');
  const iframeRef = useRef<HTMLIFrameElement | null>(null);
  const toolbarRef = useRef(null);

  const id = match?.params.id || '';
  const programId = match?.params.programId || '';
  const isExploreQuery = useQueryParam('is_explore');
  const isExplore = isExploreQuery === 'true' ? true : false;
  const isEditQuery = useQueryParam('edit');
  const isChallengeQuery = useQueryParam('challenge');
  const isPublicQuery = useQueryParam('public');
  const [isEdit, setIsEdit] = useState(isEditQuery === 'true');
  const [isChallenge, setIsChallenge] = useState(isChallengeQuery === 'true');
  const [isPublicProgram, setIsPublicProgram] = useState(isPublicQuery === 'true');
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const isTablet = useIsTablet();

  useEffect(() => {
    // TODO: This is hacky solution to change query param
    if (isEdit) {
      const queryParams = new URLSearchParams(location.search);
      queryParams.set('edit', 'true');
      updateQueryParams(queryParams);
    }
    if (isChallenge) {
      const queryParams = new URLSearchParams(location.search);
      queryParams.set('challenge', 'true');
      updateQueryParams(queryParams);
    }
  }, [isEditQuery, isChallengeQuery]);

  const [isSidebarOpened, setIsSidebarOpened] = useState<boolean>(true);
  const [goToNext, setGoToNext] = useState(false);
  const [selectedImpressions, setSelectedImpressions] = useState<string[]>([]);
  const [selectedDifficulty, setSelectedDifficulty] = useState<string>('');
  const [elaboration, setElaboration] = useState<string | undefined>(undefined);
  const [feedbackModalOpen, setFeedbackModalOpen] = useState(false);
  const [popup, setPopup] = useState<Window | null>(null);
  const [shouldGoNext, setShouldGoNext] = useState(0);
  const [presentationEnabled, setPresentationEnabled] = useState(false);
  const [isSelectModalOpen, setIsSelectModalOpen] = useState(false);

  // @ts-ignore
  const [
    state,
    updateState,
    { goToNextResource, goToFirstResource, contentLevel },
  ] = useGetUnitDataGql({
    programId: match?.params.programId,
    id: match?.params.id,
    contentLevel: match?.params.contentLevel,
    props,
    context,
  });
  console.log('state', state);

  const {
    usesNewRenderer: isProgramUsingNewContentRendering,
    usesMaxWidth,
    loading: isProgramContentRenderingLoading,
  } = useStudyGroupContentSettings(state.studyGroup?.id);

  const pinned = state.pinnings?.filter(
    (pinned) => pinned.contentId === id,
  )?.[0];
  const isChalkedUp =
    contentLevel === 'content' &&
    !!state.chalkups?.find((chalkup) => chalkup.contentId === id);
  const isShared =
    contentLevel === 'content' &&
    !!state.shares?.find((share) => share.contentId === id);

  useEffect(() => {
    if (
      (state.tracks && state.tracks.length > 0 && !state.trackId) ||
      (state.studyGroups && state.studyGroups.length > 0 && !state.studyGroupId)
    ) {
      // TODO: this is hacky solution to select a track
      if (isEdit || isChallenge) {
        let selectedTrack = state.tracks?.find((t) =>
          t.tags.includes('global'),
        );
        const selectedStudyGroup = state.studyGroups?.find((s) => {
          const track = s.tracks.find((t) => t.tags.includes('global'));
          return !!track;
        });

        if (selectedStudyGroup) {
          updateState({
            studyGroupId: selectedStudyGroup.id,
          });
        } else if (selectedTrack) {
          updateState({ trackId: selectedTrack.id });
        } else {
          setIsSelectModalOpen(true);
        }
      } else {
        setIsSelectModalOpen(true);
      }
    }
  }, [state.tracks, state.studyGroups]);

  const sidebarOpenedWithNotFoundOpened =
    isSidebarOpened && !state.trackContentNotFound;

  const toggleComplete = (gotoNext = false) => {
    if (!toolbarRef.current) {
      return;
    }
    if (!isChalkedUp) {
      // @ts-ignore
      toolbarRef.current.chalkUpContent();
      if (gotoNext)
        // no set if no true -> no rerender
        setGoToNext(true);

      // Feedback after module always
      const feedbackAfterModule = true; // context.flags.includes('feedback-after-module')
      if (
        !context.flags.includes('feedback-always') &&
        (context.namespaces.includes('tennessee') ||
          context.namespaces.includes('qatar') ||
          context.namespaces.includes('slo') ||
          context.namespaces.includes('kodingnext') ||
          feedbackAfterModule) &&
        state.trackContent &&
        state.trackModule &&
        state.trackModule.trackContents &&
        state.trackContent.id ===
          state.trackModule.trackContents[
            state.trackModule.trackContents.length - 1
          ]!.id
      ) {
        setFeedbackModalOpen(true);
      } else {
        setGoToNext(false);
        setTimeout(() => {
          goToNextResource();
        });
      }
    } else {
      // @ts-ignore
      toolbarRef.current.removeChalkUpContent();
    }
  };

  const sendFeedback = () => {
    if (selectedImpressions.length > 0 && selectedDifficulty !== '') {
      const contentPk = state.trackContent?.content.id;
      if (!contentPk || !context) {
        return;
      }
      axiosWrapper(context.content_feedback, 'post', {
        content: { pk: contentPk },
        study_group: { pk: state.studyGroup?.id },
        impressions: [...selectedImpressions, selectedDifficulty],
        elaboration,
      }).finally(() => {
        setFeedbackModalOpen(false);
        setSelectedImpressions([]);
        setSelectedDifficulty('');
        setElaboration(undefined);
        if (goToNext) {
          setGoToNext(false);
          setTimeout(() => {
            goToNextResource();
          });
        }
      });
    }
  };

  useEffect(() => {
    if (contentLevel === 'content' && (isMobile || isTablet)) {
      setIsSidebarOpened(false);
      window.scrollTo(0, 0);
    }
  }, [contentLevel, isMobile]);

  if (isExplore) {
    return (
      <>
        <>
          <OverrideBackground />
          {state.studyGroup && (
            <Title
              route={'/?tab=1'}
              unitName={
                state.trackUnit?.unit.name +
                ' ' +
                (state.contentName || state.trackContent?.content.name || '')
              }
              isUnitLoading={false}
              isSaveAvailable={false}
              buttonText="Go Back"
              isExplore={true}
            />
          )}
          <VStack
            className={props.className}
            justify="flex-start"
            h="full"
            p={0}
            position="relative"
          >
            {!popup && (
              <IconButton
                zIndex="1100"
                position="absolute"
                top="0"
                mt="4"
                left={sidebarOpenedWithNotFoundOpened ? '286px' : '32px'}
                title={
                  sidebarOpenedWithNotFoundOpened
                    ? t('guidesPage.closeSideMenu')
                    : t('guidesPage.openSideMenu')
                }
                aria-label={
                  sidebarOpenedWithNotFoundOpened
                    ? t('guidesPage.closeSideMenu')
                    : t('guidesPage.openSideMenu')
                }
                fontSize="20px"
                p="3"
                boxShadow="md"
                bg="white"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  setIsSidebarOpened((prevState) => !prevState);
                }}
                transition="all 0.5s ease"
                icon={
                  sidebarOpenedWithNotFoundOpened ? (
                    <HamburgerIcon />
                  ) : (
                    <FolderTreeIcon />
                  )
                }
              />
            )}
            <HStack
              style={{
                alignItems: 'start',
                width: '100%',
                overflow: 'unset !important',
                marginTop: '20px',
                position: 'relative',
              }}
              spacing={0}
              className={classNames([
                { 'sidebar-opened': sidebarOpenedWithNotFoundOpened },
              ])}
            >
              <Sidebar
                context={context}
                studyGroup={state.studyGroup}
                chalkups={state.chalkups}
                isModuleLoading={state.isModuleLoading}
                isSaveAvailable={state.isSaveAvailable}
                isSidebarOpened={sidebarOpenedWithNotFoundOpened}
                module={state.trackModule}
                content={state.trackContent}
                trackUnit={state.trackUnit}
                handleOpenModal={() => {}}
                isEdit={isEdit}
              />
              <VStack
                pl="104px"
                pr="32px"
                transition="500ms"
                w="full"
                sx={{
                  '.sidebar-opened &': {
                    paddingLeft: '32px',
                  },
                }}
                zIndex={0}
              >
                <>
                  {state.trackContent && (
                    <ContentComponent
                      ref={iframeRef}
                      context={context}
                      contentId={id}
                      studyGroup={state.studyGroup}
                      isChalkupsLoading={false}
                      isChalkedUp={false}
                      isTeacherGuideDisplayed={false}
                      toggleComplete={() => {}}
                      goToNextResource={() => {}}
                      popup={popup}
                      setPopup={setPopup}
                      shouldGoNext={0}
                      setShouldGoNext={() => {}}
                      updateParentState={(newState: Partial<State>) => {
                        updateState(newState);
                      }}
                      presentationEnabled={false}
                      showAllSections={true}
                      setPresentationEnabled={() => {}}
                      isExplore={true}
                      isProgramContentRenderingLoading={
                        !!isProgramContentRenderingLoading
                      }
                      isProgramUsingNewContentRendering={
                        !!isProgramUsingNewContentRendering
                      }
                    />
                  )}
                </>
                {state.isUnitLoading && <Loader />}
              </VStack>
            </HStack>
          </VStack>
        </>
      </>
    );
  }

  return (
    <>
      <OverrideBackground />
      <FeedbackModal
        isOpen={feedbackModalOpen}
        selectedImpressions={selectedImpressions}
        selectedDifficulty={selectedDifficulty}
        elaboration={elaboration}
        setSelectedImpressions={setSelectedImpressions}
        setSelectedDifficulty={setSelectedDifficulty}
        setElaboration={setElaboration}
        send={sendFeedback}
      />
      {!isEdit && !isChallenge && !isPublicProgram && (
        <SelectTrackAndStudyGroupModal
          trackId={state.trackId}
          studyGroupId={state.studyGroupId}
          tracks={state.tracks}
          studyGroups={state.studyGroups}
          updateParentState={(newState) => {
            updateState(newState);
          }}
          isOpen={
            isSelectModalOpen ||
            (state.program != null &&
              (state.trackId == null || state.studyGroupId == null) &&
              state.isStudyGroupLoading === false)
          }
          setIsOpen={setIsSelectModalOpen}
        />
      )}
      {state.studyGroup && !popup && (
        <Title
          route={ClassPage.getRoute(
            programId,
            'units',
            isEdit
              ? '?edit=true'
              : isChallenge
              ? '?challenge=true'
              : isPublicProgram
              ? '?public=true'
              : location.search,
          )}
          unitName={state.trackUnit?.unit.name}
          isUnitLoading={state.isUnitLoading}
          isSaveAvailable={false}
        >
          {!popup &&
            ((state.studyGroups && state.studyGroups.length > 1) ||
              (state.tracks && state.tracks.length > 1)) && (
              <Button
                position="absolute"
                top="14px"
                right="32px"
                onClick={() => setIsSelectModalOpen(true)}
              >
                Change{' '}
                {state.tracks && state.tracks.length > 1 && 'learning path'}
                {state.studyGroups &&
                  state.studyGroups.length > 1 &&
                  state.tracks &&
                  state.tracks.length > 1 &&
                  ' or '}
                {state.studyGroups && state.studyGroups.length > 1 && 'class'}
              </Button>
            )}
        </Title>
      )}

      <VStack
        className={props.className}
        spacing={0}
        style={{ justifyContent: 'flex-start', height: '100%', padding: '0px' }}
        position="relative"
      >
        {!popup && (
          <IconButton
            zIndex="1100"
            position="absolute"
            top="0"
            mt="4"
            left={sidebarOpenedWithNotFoundOpened ? '286px' : '32px'}
            title={
              sidebarOpenedWithNotFoundOpened
                ? t('guidesPage.closeSideMenu')
                : t('guidesPage.openSideMenu')
            }
            aria-label={
              sidebarOpenedWithNotFoundOpened
                ? t('guidesPage.closeSideMenu')
                : t('guidesPage.openSideMenu')
            }
            fontSize="20px"
            p="3"
            boxShadow="md"
            bg="white"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              setIsSidebarOpened((prevState) => !prevState);
            }}
            transition="all 0.5s ease"
            icon={
              sidebarOpenedWithNotFoundOpened ? (
                <HamburgerIcon />
              ) : (
                <FolderTreeIcon />
              )
            }
          />
        )}
        <HStack
          style={{
            alignItems: 'start',
            width: '100%',
            overflow: 'unset !important',
            position: 'relative',
          }}
          spacing={0}
          className={classNames([
            { 'sidebar-opened': sidebarOpenedWithNotFoundOpened },
          ])}
        >
          {!popup && (
            <Sidebar
              context={context}
              studyGroup={state.studyGroup}
              chalkups={state.chalkups}
              isModuleLoading={state.isModuleLoading}
              isSaveAvailable={state.isSaveAvailable}
              isSidebarOpened={sidebarOpenedWithNotFoundOpened}
              module={state.trackModule}
              content={state.trackContent}
              trackUnit={state.trackUnit}
              handleOpenModal={() => {}}
              isEdit={isEdit}
              isChallenge={isChallenge}
            />
          )}
          <VStack
            px={[2, 4, 8]}
            transition="500ms"
            w="full"
            spacing={0}
            sx={{
              '.sidebar-opened &': {
                paddingLeft: '32px',
              },
            }}
            zIndex={0}
          >
            {contentLevel === 'content' ? (
              <>
                <Toolbar
                  ref={toolbarRef}
                  programId={programId}
                  trackId={state.trackId}
                  context={context}
                  notFound={state.trackContentNotFound}
                  trackUnit={state.trackUnit}
                  trackModule={state.trackModule}
                  trackContent={state.trackContent}
                  studyGroup={state.studyGroup}
                  pinned={pinned}
                  pinnings={state.pinnings}
                  isChalkedUp={isChalkedUp}
                  chalkups={state.chalkups}
                  isChalkupsLoading={state.isChalkupsLoading}
                  isShared={isShared}
                  shares={state.shares}
                  isTeacherGuideDisplayed={state.isTeacherGuideDisplayed}
                  isSaveAvailable={state.isSaveAvailable}
                  isSaving={state.isSaving}
                  iframeRef={iframeRef}
                  popup={popup}
                  setPopup={setPopup}
                  shouldGoNext={shouldGoNext}
                  setShouldGoNext={setShouldGoNext}
                  updateParentState={(newState) => {
                    updateState(newState);
                  }}
                  toggleComplete={toggleComplete}
                  presentationEnabled={presentationEnabled}
                  setPresentationEnabled={setPresentationEnabled}
                  isProgramUsingNewContentRendering={
                    !!isProgramUsingNewContentRendering
                  }
                  isProgramContentRenderingLoading={
                    !!isProgramContentRenderingLoading
                  }
                  sidebarOpened={sidebarOpenedWithNotFoundOpened}
                />
                {state.trackContentNotFound && (
                  <VStack>
                    <Text>Content was not found.</Text>
                    <HStack>
                      {state.tracks != null && state.tracks.length > 0 && (
                        <Button
                          variant="outline"
                          colorScheme="blue"
                          onClick={() => setIsSelectModalOpen(true)}
                        >
                          Try a different learning path
                        </Button>
                      )}
                      <Button onClick={() => goToFirstResource()}>
                        Open first content
                      </Button>
                    </HStack>
                  </VStack>
                )}
                {state.trackContent && (
                  <ContentComponent
                    ref={iframeRef}
                    context={context}
                    contentId={state.trackContent?.content.id}
                    studyGroup={state.studyGroup}
                    isChalkupsLoading={state.isChalkupsLoading}
                    isChalkedUp={isChalkedUp}
                    isTeacherGuideDisplayed={state.isTeacherGuideDisplayed}
                    toggleComplete={toggleComplete}
                    goToNextResource={goToNextResource}
                    popup={popup}
                    setPopup={setPopup}
                    shouldGoNext={shouldGoNext}
                    setShouldGoNext={setShouldGoNext}
                    updateParentState={(newState: Partial<State>) => {
                      updateState(newState);
                    }}
                    presentationEnabled={presentationEnabled}
                    setPresentationEnabled={setPresentationEnabled}
                    isUsingMaxWidth={usesMaxWidth}
                    isProgramUsingNewContentRendering={
                      !!isProgramUsingNewContentRendering
                    }
                    isProgramContentRenderingLoading={
                      !!isProgramContentRenderingLoading
                    }
                  />
                )}
              </>
            ) : state && state.trackUnit?.id ? (
              state.trackUnit.trackModules?.length ? (
                <p>Select a module</p>
              ) : (
                <p>This unit is still empty.</p>
              )
            ) : null}
            {state.isUnitLoading && <Loader />}
          </VStack>
        </HStack>
      </VStack>
    </>
  );
};

export default UnitPageUnStyled;
